import { useDeviceDetectorContext } from '../../../../device-detector'
import { useExpaContext } from '../../../../expa'
import { useFirstImpressionContext } from '../../../../first-impression'
import { useGlobalConfigContext } from '../../../../global-config'
import { productPageExpaShouldShowFirstImpressionWidget } from '../../../model/productPageExpaAccessor/productPageExpaShouldShowFirstImpressionWidget'

export const useShouldRenderProductRecommendationWidgetFirstImpressionSlider =
  (): boolean => {
    const expa = useExpaContext()
    const firstImpression = useFirstImpressionContext()
    const { tenant } = useGlobalConfigContext()
    const { isMobile } = useDeviceDetectorContext()

    // https://jira.shop-apotheke.com/browse/CRO-576
    return (
      firstImpression &&
      !isMobile &&
      productPageExpaShouldShowFirstImpressionWidget({ expa, tenant })
    )
  }
